let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/* ==========================================================================
   LANDING-PAGE FREE GIFT GUARD
   --------------------------------------------------------------------------
   Only the landing-page add-to-cart buttons that offer a gift (buy box pack with a gift, and
   the final CTA band) add it, in the same request as the pack (assets/landing-page.js):
     pack line: _lp_pack = 'true'
     gift line: _lp_gift = 'true', _lp_gift_for = <pack variant id>, _lp_gift_min = <pack qty>
   Because the pack line carries its own property, it stays a separate cart line from the same
   product added anywhere else (PDP, collection, upsell). This guard counts ONLY pack lines with
   those same properties:
     - fewer than _lp_gift_min of the LP pack left in the cart -> gift removed
       (the same product added from elsewhere does not keep the gift)
     - gift quantity above 1 -> set back to 1 (safety net only)
   Only lines added AS the free gift are ever touched: they carry _lp_gift = 'true' (set by
   landing-page.js). Anything added normally has no such property and is never removed here,
   whatever the product is.
   It also keeps window.__lpGiftsInCart = { <pack variant id>: true } up to date, so
   landing-page.js does not send a second gift when the pack is added again (no gift flicker).
   Runs after every cartUpdate (after the theme's freebie chain has finished) and once on load.
   Lives in this file only because pubsub.js is loaded on every page, before cart.js.
   ========================================================================== */
(function () {
  if (window.__lpGiftGuard) return;
  window.__lpGiftGuard = true;
  window.__lpGiftsInCart = window.__lpGiftsInCart || {};

  var running = false;
  var queued = false;

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // The theme's freebie handlers hold these locks while they add/remove/refresh.
  function themeFreebieBusy() {
    return !!(
      window.isGiftProductUpdating || window._giftAddInProgress ||
      window.isRotatingGiftUpdating || window._rotGiftInProgress ||
      window.isAutoProductUpdating || window._autoAddInProgress
    );
  }

  async function checkLpGifts() {
    if (running) { queued = true; return; }
    running = true;
    var changed = false;
    try {
      for (var i = 0; i < 12 && themeFreebieBusy(); i++) await wait(150);

      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      if (!cart || !cart.items) return;

      var changes = [];
      var kept = {};
      cart.items.forEach(function (line) {
        var gp = line.properties || {};

        // Not a free gift line (no _lp_gift property): a normal purchase, never touched.
        if (gp._lp_gift !== 'true') return;

        var forId = parseInt(gp._lp_gift_for, 10);
        var min = parseInt(gp._lp_gift_min, 10) || 1;

        // Only LP pack lines (same variant + _lp_pack property) count towards the gift.
        var packQty = 0;
        cart.items.forEach(function (it) {
          var ip = it.properties || {};
          if (ip._lp_pack !== 'true') return;
          if (forId && parseInt(it.variant_id, 10) !== forId) return;
          packQty += it.quantity;
        });

        if (!forId || packQty < min || kept[forId]) {
          // Not earned, or a second gift line for the same pack: remove it.
          changes.push({ id: line.key, quantity: 0 });
          return;
        }
        kept[forId] = true;
        if (line.quantity > 1) changes.push({ id: line.key, quantity: 1 });
      });
      window.__lpGiftsInCart = kept;
      if (!changes.length) return;

      window.setFreebieLoading && window.setFreebieLoading(true);
      for (var c = 0; c < changes.length; c++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(changes[c])
        });
      }
      changed = true;
      await wait(120);

      // Same refresh the theme's freebie handlers use (cart page vs drawer).
      if (document.querySelector('cart-items')) {
        if (window.refreshCart) await window.refreshCart();
      } else if (window.refreshCartDrawer) {
        await window.refreshCartDrawer();
      }
    } catch (e) {
      console.error('[LP gift] check failed', e);
    } finally {
      if (changed) window.setFreebieLoading && window.setFreebieLoading(false);
      running = false;
      if (queued) { queued = false; checkLpGifts(); }
    }
  }

  window.checkLpGifts = checkLpGifts;

  function hook() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      // Let the theme's sequential freebie chain finish first, then check.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(checkLpGifts, 700); });
    }
    checkLpGifts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
